import React, { Component, Fragment } from 'react';
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import ReactDatatable from '@ashvin27/react-datatable';
import { toastr } from "react-redux-toastr"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from "react-bootstrap";

import {
    getData
    , enviaRegistrosPrdLst
    , getDataTdsRevendas

} from "./custPrdLstActions"
import { logout } from "./../../../auth/authActions"

import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

class CustPrdLst extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []

            , arrayEnviarTodos_Id: []
            , arrayEnviarTodos_codCatIte: []

            , arrayEnviar_Id: []
            , arrayEnviar_codCatIte: []

            , SelPuxada: 0
            , booLerRecords: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? true : false)
            , MsgModal2: ""
            , isModalOpen: 0

        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            this.props.getData(this.props.codPuxada);
        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action1",
                text: "",
                className: "action1",
                width: 30,
                align: "center",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "reseller",
                text: "Reseller",
                className: "reseller",
                align: "left",
                sortable: true
            },
            {
                key: "id",
                text: "Id",
                className: "id",
                align: "left",
                sortable: true,
                width: 200

            },
            {
                key: "codCatIte",
                text: "CodCatIte",
                className: "codCatIte",
                align: "left",
                sortable: true,
                width: 100
            },
            {
                key: "productId",
                text: "ProductId",
                className: "productId",
                align: "left",
                sortable: true
            },
            {
                key: "createdAtStaging",
                text: "CreatedAtStaging",
                className: "createdAtStaging",
                sortable: true,
                align: "left"
            },
            {
                key: "updatedAtStaging",
                text: "UpdatedAtStaging",
                className: "updatedAtStaging",
                sortable: true,
                align: "left"
            },
            {
                key: "sendToHybrisStatus",
                text: "SndToHyStt",
                className: "sendToHybrisStatus",
                sortable: true,
                align: "left"
            },
            {
                key: "sendToHybrisAt",
                text: "SendToHybrisAt",
                className: "sendToHybrisAt",
                sortable: true,
                align: "left"
            },

        ];
        this.config = {
            key_column: 'reseller, id, codCatIte',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: true,
            },
            filename: "CustPrdLst",

            language: {
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
                , loading: "True"
            }

        }

        this.extraButtons = [
            {
                className: "btn btn-success  ",
                title: "Exporta Selecionados",
                children: [
                    <img src={minhaImagemSelc} alt="" ></img>

                ],
                onClick: () => { this.ExportaSelecao(); },
            },
            {
                className: "btn btn-success ",
                title: "Exporta Todos",
                children: [
                    <img src={minhaImagemTodos} alt="" ></img>

                ],
                onClick: () => { this.ExportaTodos(); },
            },
        ]

        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);

        this.PopulararrayEnviarTodos = this.PopulararrayEnviarTodos.bind(this);
        this.setPuxada = this.setPuxada.bind(this);
        this.setbscInf = this.setbscInf.bind(this);
    }

    setPuxada(e) {
        this.setState({
            SelPuxada: (e.target.value === "" ? 0 : e.target.value)
            , booLerRecords: false
        });
    }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }

    closeModal = () => this.setState({ isModalOpen: 0, LimpaRegReposta: true })

    setbscInf() {
        if (this.state.SelPuxada === null || Number(this.state.SelPuxada) === 0) {
            toastr.warning("Atenção Selecione uma Revenda")
        }
        else {
            this.setState({
                MsgModal2: "Processando solicitação..."
            });
            this.openModal(2)
            this.props.getData(this.state.SelPuxada);
            setTimeout(() => {
                this.setState({
                    booLerRecords: true
                    , isModalOpen: 0
                });
            }, 500);
        }
    }

    PopulararrayEnviarTodos() {

        this.setState({
            arrayEnviarTodos_Id: []
            , arrayEnviarTodos_codCatIte: []
        });

        if (this.props.redListaCustPrdLst !== undefined && this.props.redListaCustPrdLst !== null) {
            for (let i = 0, l = this.props.redListaCustPrdLst.length; i < l; i++) {
                this.state.arrayEnviarTodos_Id.push(this.props.redListaCustPrdLst[i].id);
                this.state.arrayEnviarTodos_codCatIte.push(this.props.redListaCustPrdLst[i].codCatIte);
            }
        }
    }


    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2_id = [];
        const array2_CodCatite = [];

        let Existe = [{}];

        Existe =
            (
                this.state.arrayMarcados
                    .filter((a) => a.id === registro.id &&
                        a.CodCatite === registro.codCatIte
                    )
            )


        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)

            this.state.arrayEnviar_Id.push(registro.id);
            this.state.arrayEnviar_codCatIte.push(registro.codCatIte);

        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].id === registro.id &&
                    this.state.arrayMarcados[i].codCatIte === registro.codCatIte) { }
                else {
                    array1.push(this.state.arrayMarcados[i]);
                    array2_id.push(this.state.arrayMarcados[i].id);
                    array2_CodCatite.push(this.state.arrayMarcados[i].codCatIte);
                }
            }

            this.setState({
                arrayEnviar_Id: array2_id
                , arrayEnviar_codCatIte: array2_CodCatite
                , arrayMarcados: array1
            });

        }
    }

    ExportaSelecao() {
        if (this.state.arrayMarcados.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaRegistrosPrdLst(
                this.state.arrayEnviar_Id
                , this.state.arrayEnviar_codCatIte
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar_Id: []
                    , arrayEnviar_codCatIte: []
                    , isModalOpen: 0
                });
            }, 4000);

        }

    }

    ExportaTodos() {

        this.PopulararrayEnviarTodos();
        let podeenviar = true;

        if (this.state.arrayEnviarTodos_Id.length === 0) {
            toastr.warning("Não há Grupo e Custo a enviar !!!!")
            podeenviar = false
        }
        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (this.state.SelPuxada === undefined
                || this.state.SelPuxada === null
                || this.state.SelPuxada === 0) {
                toastr.warning("Revenda não selecionada !!!!")
                podeenviar = false;
            }
        }

        if (podeenviar === true) {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaRegistrosPrdLst(
                this.state.arrayEnviarTodos_Id
                , this.state.arrayEnviarTodos_codCatIte
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar_Id: []
                    , arrayEnviar_codCatIte: []
                    , loading: true
                    , isModalOpen: 0

                });
            }, 4000);
        }
    }

    // editRecord(record) {
    //     console.log("Edit Record", record);
    // }

    // MrcDesRecord(event, record) {
    //     if (event.onChange){
    //         console.log("Edit Record: ", record);
    //         console.log("checked: ", event.onChange);

    //     }
    //     else
    //     {
    //         console.log("Edit Record: ", record);
    //         console.log("deschecked: ", event.onChange);
    //     }
    // }
    // MrcDesRecord = (e, record) => {
    //     console.log("Edit record: " + record);
    //     console.log("Selecao: " + (e.type === 'checkbox' ? e.checked : e.value));
    // }

    render() {
        const Listapuxadas = this.props.redListaTdsRevendas || [];

        return (

            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Customer Product List</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    {/* <div className="col-md-2">
                        <span className="cadastro-Externos1">&nbsp;
                            <span className="text-style-1">Código da Revenda: </span>
                        </span>
                    </div> */}
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                        {/* </div>
                    <div className="col"> */}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ fontSize: "18px", color: "#77b935" }}
                            data-toggle="tooltip"
                            title="Adiciona a Lista"
                            onClick={this.setbscInf}

                        >
                            <i className="fa fa-refresh " aria-hidden="true"></i>
                        </button>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                        , fontSize: "12px", color: "#77b935"
                    }}>
                    <div className="Col">
                        <span className="cadastro-Externos1">&nbsp;
                            <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div>
                    <ReactDatatable
                        config={this.config}
                        records={(this.state.booLerRecords === true ? this.props.redListaCustPrdLst || [] : [])}
                        // records={ListaCustPrdLst || []}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    />
                </div>
                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

            </div>
        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , redListaTdsRevendas: state.custPrdLstReducer.ListaTdsRevendas
        , redListaCustPrdLst: state.custPrdLstReducer.listaCustPrdLst
    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getData
        , enviaRegistrosPrdLst
        , logout
        , getDataTdsRevendas
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CustPrdLst)